//export const API_BASE_URL = "https://ecomoria-backend.onrender.com/api";
//export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
// src/web/client/src/constants.js

// תיקון סופי - מחזירים את /api
//export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://api.ecomoria.com/api";

// File: src/web/client/src/constants.js

// בפיתוח: השתמש ב-localhost
// בפרודקשן: השתמש ב-api.ecomoria.com
//export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:3000/api";

// בפיתוח: השתמש ב-localhost
// בפרודקשן: השתמש ב-api.ecomoria.com
/*export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 
  (window.location.hostname === 'localhost' 
    ? "http://localhost:3000/api" 
    : "https://api.ecomoria.com/api");
*/
    // src/web/client/src/constants.js
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://api.ecomoria.com/api";

/*export const API_BASE_URL =
import.meta.env.VITE_API_URL
?? (location.hostname === 'localhost'
    ? 'http://localhost:3000/api'
    : 'https://api.ecomoria.com/api');
*/
// הגדרות נוספות
export const APP_NAME = "Ecomoria";
export const DEFAULT_SHOP_ID = "68120a578f0291083087b9b8";

// הוסף log לדיבוג
console.log('API_BASE_URL configured as:', API_BASE_URL);